// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"245cf676","453":"e2178a37","664":"17c5884e"}[chunkId] + ".chunk.js";
};